/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { MessageId } from "../../commons/types/MessageId";
import { ThreadId } from "../../commons/types/ThreadId";
import { MessageRole } from "./MessageRole";
export const MessageModel = core.serialization.object({
    id: MessageId,
    threadId: ThreadId,
    messageId: core.serialization.string().optional(),
    content: core.serialization.record(core.serialization.string(), core.serialization.any()),
    parts: core.serialization
        .list(core.serialization.record(core.serialization.string(), core.serialization.any()))
        .optional(),
    annotations: core.serialization
        .list(core.serialization.record(core.serialization.string(), core.serialization.any()))
        .optional(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    role: MessageRole,
    state: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
});
